<div class="col-12 static-card sub-step-card"
    [ngClass]="{ 'filter-separator' : filterIndex > 0, 'hide-background-filter': !userHasFilter }"
    (window:resize)="onResize($event)">
    <div class="row" [ngClass]="{ 'hide-filter': !userHasFilter }">
        <div class="col-12 row pr-0">
            <div class="col chips d-flex align-items-center pr-0">
                <div class="filter-container">
                    <div class="filter-box"
                        [ngClass]="{ 'filter-box-1' : filterIndex == 0, 'filter-box-2': filterIndex == 1, 'filter-box-3' : filterIndex == 2, 'filter-box-4' : filterIndex == 3, 'filter-box-5' : filterIndex == 4, 'filter-box-6' : filterIndex == 5}">
                    </div>
                    <span class="filter-box-text" *ngIf="filterName">{{ filterName }}</span>
                </div>
                <div class="d-grid">
                    <div #chipsDivOuter class="chipsDivOuter"
                        [ngClass]="{'viewMore': viewMore, 'center-chips': !lessMoreIsVisible }">
                        <div #chipsDiv class="resultBox-containter">
                            <span class="resultBox result-box-text" (click)="showFilter()">{{setyear}} <a
                                    (click)="setyear = currentYear;" *ngIf="setyear != currentYear"><img
                                        src="assets/ph-bhp-evaluation/icon-close-filter.svg"
                                        class="closeIcon"></a></span>
                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="setCountry && roleId == 1">{{setCountry.countryName | translate}}
                                <a (click)="countryRemoved(true);"><img
                                        src="assets/ph-bhp-evaluation/icon-close-filter.svg" class="closeIcon">
                                </a>
                            </span>
                            <span class="resultBox result-box-text" *ngIf="!setCountry && roleId == 1">
                                {{ 'EVALUATION.All.COUNTRIES' | translate }}
                            </span>
                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="setInstitution">{{setInstitution.institutionName | labelSanitizer}}
                                <a (click)="institutionRemoved(true);">
                                    <img *ngIf="!singleInstitution" src="assets/ph-bhp-evaluation/icon-close-filter.svg"
                                        class="closeIcon">
                                </a>
                            </span>
                            <span class="resultBox result-box-text" (click)="showFilter()" *ngIf="!setInstitution">
                                {{ 'EVALUATION.All.INSTITUTIONS' | translate }}
                            </span>

                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="setDepartment && showMultiselectChip('dept')">
                                {{setDepartment.departmentName | translate | labelSanitizer}}
                                <a (click)="departmentRemoved()">
                                    <img src="assets/ph-bhp-evaluation/icon-close-filter.svg" class="closeIcon">
                                </a>
                            </span>
                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="!setDepartment && showMultiselectChip('dept')">
                                {{ 'EVALUATION.All.DEPARTMENTS' | translate }}
                            </span>

                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="setDepartmentType && showMultiselectChip('deptType')">
                                {{setDepartmentType.departmentTypeName | translate | labelSanitizer}}
                                <a (click)="departmentTypeRemoved()">
                                    <img src="assets/ph-bhp-evaluation/icon-close-filter.svg" class="closeIcon">
                                </a>
                            </span>
                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="!setDepartmentType && showMultiselectChip('deptType')">
                                {{ 'EVALUATION.All.DEPARTMENT_TYPES' | translate }}
                            </span>

                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="setWard && showMultiselectChip('ward')">
                                {{setWard.wardName | translate | labelSanitizer}}
                                <a (click)="wardRemoved();">
                                    <img src="assets/ph-bhp-evaluation/icon-close-filter.svg" class="closeIcon">
                                </a>
                            </span>
                            <span class="resultBox result-box-text" (click)="showFilter()"
                                *ngIf="!setWard && showMultiselectChip('ward')">
                                {{ 'EVALUATION.All.WARDS' | translate }}
                            </span>

                            <span class="resultBox result-box-text" (click)="deselectEntry($event, entry, true)"
                                *ngFor="let entry of entriesSelectedChips">
                                {{entry.name | translate | labelSanitizer}}
                                <a>
                                    <img src="assets/ph-bhp-evaluation/icon-close-filter.svg" class="closeIcon">
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="" *ngIf="lessMoreIsVisible">
                        <button class="viewMoreButton" (click)="viewMore = !viewMore">{{ (viewMore?
                            'EVALUATION.SEE_LESS' : 'EVALUATION.SEE_MORE') | translate }}</button>
                    </div>
                </div>
            </div>

            <div class="col-auto d-flex align-items-center pr-0 ml-1">
                <div class="col-auto d-flex align-items-center p-1" *ngIf="filterIndex > 0">
                    <button class="btn-edit-icon trash-button" (click)="removeFilter()">
                        <img src="assets/ph-bhp-layout/svg/icon-delete.svg">
                    </button>
                </div>
                <a class="btn-edit-icon" (click)="showFilter()">
                    <img src="assets/ph-bhp-layout/svg/icon-edit.svg">
                </a>
            </div>
        </div>
    </div>
    <lib-ph-bhp-sidepanel [showsidebar]="singleCard" [isFilterCard]="true" (childData)="closeSidebarEvent($event)">
        <div class="filter-card" *ngIf="singleCard">
            <div class="filter-header">
                <h2 class="page-title" *ngIf="!userHasFilter || isNewFilter">{{'CONFIGURE.FILTERS.NEW_FILTER' |
                    translate }}</h2>
                <h2 class="page-title" *ngIf="userHasFilter && !isNewFilter">{{'CONFIGURE.FILTERS.EDIT_FILTER' |
                    translate }}</h2>
                <div class="clear-box" *ngIf="getActiveFilters() > 0 || showMultiselect" (click)="resetFilter()">
                    <span class="clear-message mr-3">{{'CONFIGURE.FILTERS.CLEAR_ALL' | translate }}</span>
                    <div class="d-flex clear-chip" *ngIf="getActiveFilters() > 0">
                        <span class="clear-chip-number"> {{ getActiveFilters() }} </span>
                    </div>
                </div>
            </div>

            <div>
                <div class="filter form-group">
                    <mat-form-field>
                        <mat-label>{{ 'CONFIGURE.FILTERS.FILTER_NAME' | translate }}</mat-label>
                        <input matInput type="text" [(ngModel)]="filterName" maxlength="50" />
                    </mat-form-field>
                </div>
            </div>

            <div>
                <div class="filter form-group">
                  <div class="dropdown dropdown-bhp">
                    <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                      <input class="dropdown-toggle bg-white" type="text" [(ngModel)]="setyear" readonly />
                      <span class="label-dropdown">{{ 'CONFIGURE.YEAR' | translate }}</span>
                      <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                    </div>
                    <ul class="dropdown-menu">
                      <li class="dropdown-item" *ngFor="let year of previousYears" [Value]="year" (click)="onYearChange(year)">
                        {{year}}</li>
                    </ul>
                  </div>
                </div>
              </div>
            
            <div *ngIf="roleId == 1">
                <div class="filter form-group">
                    <div class="dropdown dropdown-bhp">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input class="dropdown-toggle bg-white" type="text"
                                [ngModel]="country.countryName | labelSanitizer" readonly />
                            <span class="label-dropdown">{{ 'AUTHORIZATION.COUNTRY' | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu" [compareWith]="compareCountryFn">
                            <li value="0" class="dropdown-item" (click)="onCountryChange(0)"> {{
                                'EVALUATION.All.COUNTRIES' | translate }}</li>
                            <li class="dropdown-item" *ngFor="let country of countryList" [Value]="country"
                                (click)="onCountryChange(country)">{{country.countryName | labelSanitizer}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div class="filter form-group m-0">
                    <div class="dropdown dropdown-bhp">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input class="dropdown-toggle bg-white" type="text" [disabled]="singleInstitution"
                                [ngModel]="institution.institutionName | translate" readonly />
                            <span class="label-dropdown">{{ 'EVALUATION.GROUP_OR_INSTITUTION' | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu" [compareWith]="compareInstitutionFn">
                            <li value="0" class="dropdown-item" *ngIf="!singleInstitution"
                                (click)="onInstitutionChange(0)"> {{ 'EVALUATION.All.INSTITUTIONS' | translate }}</li>
                            <li class="dropdown-item" *ngFor="let institution of institutionsList" [Value]="institution"
                                (click)="onInstitutionChange(institution)">{{institution.institutionName |
                                labelSanitizer}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <hr class="my-4 filter-separator">
            <div>
                <div class="filter form-group">
                    <div class="dropdown dropdown-bhp">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false"
                            [disabled]="showMultiselect && entrySelected.entryId == 'dept'">
                            <input class="dropdown-toggle bg-white" type="text"
                                [ngModel]="department.departmentName | translate | labelSanitizer" readonly
                                [disabled]="showMultiselect && entrySelected.entryId == 'dept'" />
                            <span class="label-dropdown">{{ translationKeys.Configure.Department | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu" [compareWith]="compareDepartmentFn">
                            <li value="0" class="dropdown-item" (click)="onDepartmentChange(0)"> {{
                                'EVALUATION.All.DEPARTMENTS' | translate }}</li>
                            <li class="dropdown-item" *ngFor="let dep of departmentList" [Value]="dep"
                                (click)="onDepartmentChange(dep)">{{dep.departmentName | translate | labelSanitizer}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div class="filter form-group">
                    <div class="dropdown dropdown-bhp">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false"
                            [disabled]="showMultiselect && entrySelected.entryId == 'deptType'">
                            <input class="dropdown-toggle bg-white" type="text"
                                [ngModel]="departmentType.departmentTypeName | translate | labelSanitizer" readonly
                                [disabled]="showMultiselect && entrySelected.entryId == 'deptType'" />
                            <span class="label-dropdown">{{ 'CONFIGURE.DEPARTMENT_TYPE' | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu" [compareWith]="compareDepartmentTypeFn">
                            <li value="0" class="dropdown-item" (click)="onDepartmentTypeChange(0)"> {{
                                'EVALUATION.All.DEPARTMENT_TYPES' | translate }}</li>
                            <li class="dropdown-item" *ngFor="let type of departmentTypeList" [Value]="type"
                                (click)="onDepartmentTypeChange(type)">{{type.departmentTypeName | translate |
                                labelSanitizer}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div class="filter form-group">
                    <div class="dropdown dropdown-bhp">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false" [disabled]="showMultiselect && entrySelected.entryId == 'ward'">
                            <input class="dropdown-toggle bg-white" type="text"
                                [ngModel]="ward.wardName | translate | labelSanitizer" readonly [disabled]="showMultiselect && entrySelected.entryId == 'ward'"/>
                            <span class="label-dropdown">{{ translationKeys.Configure.Ward | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu" [compareWith]="compareWardFn">
                            <li value="0" class="dropdown-item" (click)="onWardChange(0)"> {{ 'EVALUATION.All.WARDS' |
                                translate }}</li>
                            <li class="dropdown-item" *ngFor="let ward of wardListLoaded" [Value]="ward"
                                (click)="onWardChange(ward)">{{ward.wardName | translate | labelSanitizer}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 p-0 mb-2" *ngIf="isMultiselectReport">
                <input type="checkbox" class="custom-control-input " id="showMultiselect" [(ngModel)]="showMultiselect"
                    (change)="toggleMultiselect($event)">
                <label class="multiselectCheck" for="showMultiselect">{{ 'EVALUATION.COMPARE_MULTIPLE' | translate
                    }}</label>
            </div>
            <div *ngIf="showMultiselect">
                <div class="filter form-group">
                    <div class="dropdown dropdown-bhp">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <input class="dropdown-toggle bg-white" type="text"
                                [ngModel]="multiselectOption | translate | labelSanitizer" readonly />
                            <span class="label-dropdown">{{ 'EVALUATION.COMPARE_ENTRY' | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu" [compareWith]="compareEntryFn">
                            <li class="dropdown-item" *ngFor="let entry of showEntries" [Value]="entry"
                                (click)="onEntryChange(entry)">{{entry.name | translate | labelSanitizer}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div *ngIf="showMultiselect">
                <div class="filter form-group">
                    <div class="dropdown dropdown-bhp multiSelectFilter">
                        <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                            <!-- <div *ngIf="allEntriesChecked">
                                <input class="multiSelectInput" type="text"
                                    [ngModel]="entryAllSelectedText | translate | labelSanitizer" readonly />
                            </div> -->
                            <div *ngIf="entryNothingSelected">
                                <input class="multiSelectInput" type="text"
                                    [ngModel]="'EVALUATION.FILTERS.SELECT_VALUES' | translate | labelSanitizer" readonly />
                            </div>
                            <div class="multiSelectFilterInner" *ngIf="!entryNothingSelected">
                                <span class="resultBox result-box-text" (click)="deselectEntry($event, entry)"
                                    *ngFor="let entry of (getEntriesSelected() || [])">
                                    {{entry.name | translate | labelSanitizer}}
                                    <a>
                                        <img src="assets/ph-bhp-evaluation/icon-close-filter.svg" class="closeIcon">
                                    </a>
                                </span>
                            </div>
                            <span class="label-dropdown">{{ 'EVALUATION.COMPARE_VALUES' | translate }}</span>
                            <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg" />
                        </div>
                        <ul class="dropdown-menu">
                            <li value="0" class="dropdown-item" *ngFor="let entry of entriesSelected"
                                (click)="$event.stopPropagation()">
                                <input type="checkbox" class="custom-control-input " id="{{entry.entryId}}"
                                    [(ngModel)]="entry.selected"
                                    [disabled]="!entry.selected && selectedEntriesCount >= 6"
                                    (change)="toggleEntry($event, entry)">
                                <label class="multiselectCheck" for="{{entry.entryId}}">{{ entry.name | translate
                                    }}</label>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 filter-buttons d-flex"
                    [ngClass]="!filterButtonPosition ? 'filter-buttons-position' : ''">
                    <button class="btn-bd-empty mr-3 filter-button" (click)="cancelFilter()">{{
                        'CONFIGURE.FILTERS.CANCEL' | translate
                        }}</button>
                    <button class="btn-bd filter-button" (click)="setFilter()">{{ 'CONFIGURE.FILTERS.APPLY_FILTER' |
                        translate
                        }}</button>
                </div>
            </div>
        </div>
    </lib-ph-bhp-sidepanel>
</div>